import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Check from '@material-ui/icons/Check';
import { useStore } from 'core/store';
import useStyles from './step-rail.styles';

export const QUOTE_STEPS = [
  { title: "Who's covered", hint: 'Applicant, drivers, and household' },
  { title: 'What we found', hint: 'Review property & vehicle details' },
  { title: 'Coverage', hint: 'Limits and deductibles' },
  { title: 'Review & purchase', hint: 'Checklist, then purchase' }
];

const StepRail = observer(() => {
  const classes = useStyles();
  const { offer: store } = useStore();
  return (
    <nav aria-label="Quote steps">
      <ol className={classes.steps}>
        {QUOTE_STEPS.map((step, index) => (
          <li
            key={step.title}
            className={classNames(classes.step, { [classes.activeStep]: store.quoteStep === index + 1 })}
          >
            <button
              type="button"
              disabled={store.loading}
              className={classes.stepButton}
              onClick={() => store.setQuoteStep(index + 1)}
              aria-current={store.quoteStep === index + 1 ? 'step' : undefined}
            >
              <span className={classNames(classes.number, { [classes.previous]: store.quoteStep > index + 1 })}>
                {store.quoteStep > index + 1 ? <Check fontSize="small" aria-label="Previous step" /> : index + 1}
              </span>
              <span className={classes.stepText}>
                <span className={classes.title}>{step.title}</span>
                <span className={classes.hint}>{step.hint}</span>
              </span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
});
export default StepRail;
